const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		usage: 'management',
		grantAllAddressTypes: false,
		selectionOptions: {},
		resourceConnected: false,
	},

	model: {
		forwardFilterChanges: false,
		forceViewChange: false,
		lastAddressType: '',
		lastIsCompany: null
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.addressTable){
					event.data.component.model.addressTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.addressTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};
				attributes.listOfCategoryDataIDs = []
				var categoriesData = ((data.children || {}).cms_entities_categories || {}).data || []
				var d, categoryDataID;

				for(d in categoriesData){
					if((categoryDataID = (categoriesData[d].attributes || {}).categoryDataID)){
						attributes.listOfCategoryDataIDs.push(parseInt(categoryDataID, 10));
					}
				}

				var typesChanged = false;
				var lastAddressType = this.model.lastAddressType;
				if(attributes.addressType != this.model.lastAddressType) {
					this.model.lastAddressType = attributes.addressType;
					typesChanged = true;
				}
				if(attributes.isCompany != this.model.lastIsCompany) {
					this.model.lastIsCompany = attributes.isCompany;
					typesChanged = true;
				}
				if(typesChanged || this.model.forceViewChange){
					getComponent('artCrmController').propertiesFormChangeView('address', {
						lastAddressType,
						grantAllAddressTypes: 		this.config.grantAllAddressTypes,
						selectionOptions: 			this.config.selectionOptions,
						addressType: 				attributes.addressType,
						isCompany: 					attributes.isCompany,
						$container: 				this.$,
						usage: 						this.config.usage,
					});
				}

				if(attributes.addressType !== 'journalist'){
					delete attributes.journalist_infoInAdvance;
					delete attributes.journalist_infoInAdvanceXXL;
				}

				if(attributes.addressType !== 'media'){
					delete attributes.media_circulation;
					delete attributes.media_pagePrice;
				}

				this.model.addressTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller;
				});
			}
			if(!self.model.addressTable && self.model.controller){
				self.model.controller.find('templates_artCrm_address_table', function(table){
					self.model.addressTable = table;
				});
			}

			this.model.forwardFilterChanges = true;
			this.config.usage = self.model.controller.config.usage;
			this.config.grantAllAddressTypes = false;
			this.config.selectionOptions = {};
			let toggle
			if(this.config.usage === 'selection'){
				const selectionOptions = this.config.selectionOptions = this.getResourceRegisterContent('selection') || {};
				this.config.grantAllAddressTypes = this.getResourceRegisterContent('grantAllAddressTypes') || false;

				// NOTE: the toggle gets merely hidden than disabled. just select the right value to prevent issues due to default value triggers overwriting this selection.
				if(selectionOptions.addressType){
					const addressTypeToggle = getComponent(this.$.find('[data-field-code="addressType"]'), true)
					if(addressTypeToggle){
						addressTypeToggle.select(selectionOptions.addressType)
					}
				}

				if(selectionOptions.connectionInclusive !== undefined && selectionOptions.connectionInclusive !== null){
					toggle = getComponent(this.$.find('[data-field-code="connectionInclusive"]'), true)
					if(toggle){
						toggle.select(selectionOptions.connectionInclusive ? 1 : 0)
					}
				}

				if(selectionOptions.hasActiveNewsletterEmail !== undefined){
					toggle = getComponent(this.$.find('[data-field-code="hasActiveNewsletterEmail"]'), true)
					if(toggle){
						if(selectionOptions.hasActiveNewsletterEmail === null){
							toggle.select(null)
						} else {
							toggle.select(selectionOptions.hasActiveNewsletterEmail ? 1 : 0)
						}
					}
				}
			}
			if(this.config.usage === 'selection' || Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.model.forceViewChange = true;
				this.onChange();
				this.model.forceViewChange = false;
			}
		}
	}
}